import { useGetAgreedPlacePicture } from '@dhl/receiver-preference-api'

import { useGetDeliveryPreferenceForAddress } from './useGetDeliveryPreferenceForAddress.js'
import { type EnrichedDeliveryPreference, type AgreedPlaceFormValues } from '../model/model.js'

type ReturnValue = {
  initialFormValues: AgreedPlaceFormValues
  isLoading: boolean
  isLoadingPhoto: boolean
  isLoadingPreference: boolean
  preference?: EnrichedDeliveryPreference
}

export const useGetAgreedPlacePreference = (addressId?: string): ReturnValue => {
  const { data: preferenceData, isLoading: isLoadingPreference } = useGetDeliveryPreferenceForAddress(addressId)

  const { data: agreedPlacePhoto, isFetching: isFetchingPhoto } = useGetAgreedPlacePicture(addressId!, {
    query: {
      enabled: !!addressId,
    },
  })

  const initialFormValues: AgreedPlaceFormValues = {
    agreedPlacePhoto,
    description: preferenceData?.preference?.agreedPlaceSettings?.description ?? '',
    termsAccepted: false,
  }

  if (isLoadingPreference || isFetchingPhoto) {
    return {
      initialFormValues,
      isLoading: true,
      isLoadingPhoto: isFetchingPhoto,
      isLoadingPreference,
    }
  }

  return {
    initialFormValues,
    isLoading: false,
    isLoadingPhoto: false,
    isLoadingPreference: false,
    preference: preferenceData?.preference,
  }
}
